import axios from "../../axiosInstance";

interface UploadIconResponse {
  url: string;
}

export const uploadBadgeIcon = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post<UploadIconResponse>(
    "/api/badges/upload-icon",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data.url;
};

export default uploadBadgeIcon;
